import { isArray, get } from 'lodash';

// This is duplicated in shared-components
const showError = (errorMessage, error) => {
  return errorMessage || (isArray(error) ? get(error, '0', error) : error);
};

export default showError;
